const SellerBenchMarkCard = (props: {
    image: string;
    title: string;
    author: string;
    priceMin: number;
    priceMax: number;
    extra?: string;
}) => {
    const { title, author, image, extra, priceMin, priceMax } = props;

    const priceLabel = priceMin != null && priceMax != null
        ? `${priceMin}€ – ${priceMax}€`
        : priceMin != null
        ? `À partir de ${priceMin}€`
        : `Jusqu'à ${priceMax}€`;

    return (
        <div
            className={`flex w-full flex-col overflow-hidden rounded-xl border border-leadrs-stroke bg-white ${extra ?? ''}`}
        >
            {/* Image */}
            {image ? (
                <img src={image} className="h-[140px] w-full object-cover" alt="" />
            ) : (
                <div className="flex h-[140px] w-full items-center justify-center bg-leadrs-bg">
                    <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">{author}</p>
                </div>
            )}

            {/* Body */}
            <div className="flex flex-1 flex-col gap-3 p-5">
                <div>
                    <p className="font-geist text-xs font-semibold uppercase tracking-widest text-leadrs-text-soft">
                        {author}
                    </p>
                    <p className="mt-1 font-crimson text-lg font-semibold leading-tight text-leadrs-text">
                        {title}
                    </p>
                </div>

                <span className="w-fit rounded-full bg-leadrs-green-soft px-3 py-1 font-geist text-xs font-semibold text-leadrs-green-focus">
                    {priceLabel} / lead
                </span>

            </div>
        </div>
    );
};

export default SellerBenchMarkCard;
